<nz-alert
  class="offline-alert"
  *ngIf="(isOnline | async) === false"
  nzType="warning"
  nzBanner
  nzMessage="No Internet Connection"
  nzDescription="Unable to connect to the server. Please check your internet connection and try again.">
</nz-alert>
<nz-spin
  [nzSize]="'large'"
  [nzIndicator]="loading"
  [nzSpinning]="globalLoading | async">
  <router-outlet></router-outlet>
</nz-spin>
<ng-template #loading>
  <div class="h-screen flex justify-center items-center fixed top-0 right-0 left-0 bottom-0">
    <div>
      <i
        nz-icon
        nzType="loading"
        nzTheme="outline"
        style="font-size: 3rem"
        class="mb-4"></i>
      <p class="text-primary">Processing...</p>
    </div>
  </div>
</ng-template>
